module.exports = __webpack_public_path__ + "img/quality-control.6c5b38ce.jpg";